import I18n from '~/src/common/services/I18n';
import { formatPhone } from '~/src/common/utils/text';

export const required = () => I18n.t('form.validation.required');

/* string validation */

export const minLength = (length: number) => I18n.t('form.validation.minLength', { length });

export const maxLength = (length: number) => I18n.t('form.validation.maxLength', { length });

// Regex pour e-mail issue d'ajv : ligne 64 de -> https://github.com/ajv-validator/ajv-formats/blob/master/src/formats.ts
const RE =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const email = () => (value?: string) => {
  return (value != null && RE.test(value)) || I18n.t('form.validation.email');
};

export const phone = () => (value?: string) => {
  // 0601020304 - ok
  // 0001020304 - ko
  // 1001020304 - ko
  // 0033101020304 - ko
  // 01 02 03 04 05 - ok
  // 01.02.03.04.05 - ok
  // 01-02-03-04-05 - ok
  // 01---0...2-0 3  0 4-0.5- - ok
  const re = /^0[1-9][0-9]{8}$/;

  const formattedValue = formatPhone(value);

  return (formattedValue != null && re.test(formattedValue)) || I18n.t('form.validation.phone');
};

/* number validation */

export const min = (minValue: number) => I18n.t('form.validation.min', { min: minValue });

export const max = (maxValue: number) => I18n.t('form.validation.max', { max: maxValue });

/* promo code */
export const promoCode = () => (value: string) => {
  const re = /^[A-Za-z\d-]+$/;

  return re.test(value) || I18n.t('form.validation.promo-code');
};

/* password */
export const atLeast1Lowercase = (value: string) =>
  /[a-z]/.test(value) || I18n.t('form.validation.at-least-1-lowercase');

export const atLeast1Uppercase = (value: string) =>
  /[A-Z]/.test(value) || I18n.t('form.validation.at-least-1-uppercase');

export const atLeast1Number = (value: string) =>
  /\d+/.test(value) || I18n.t('form.validation.at-least-1-number');

export const atLeast8Char = (value: string) =>
  value.length >= 8 || I18n.t('form.validation.at-least-8-char');

export const withoutOnlyWhitespace = (value?: string) => {
  // Vérifie que la chaîne ne contient pas uniquement des espaces
  if (value && value.trim().length > 0) return true;

  return I18n.t('form.validation.required');
};

export const onlyAlphabeticCharacters = (value?: string) => {
  if (value && /^[a-zà-ú\-\s]+$/i.test(value)) return true;

  return I18n.t('form.validation.only-alphabetic-characters');
};
